import {
  getInteraccionesUnDia,
  getMonitoreoUsuario,
  getPersonaMonitoreo,
} from "../services/monitoreo.service";
import { useMonitoreoPersonalStore } from "../store/monitoreoPersonal";

const { setEstadisticasPersona, setInteraccionesUnDia } = useMonitoreoPersonalStore.getState();

export const getPersonalMonitoreoHandler = async (setPersonalMonitoreo) => {
  const result = await getPersonaMonitoreo();
  if (result) {
    setPersonalMonitoreo(result);
  }
};

export const getMonitoreoUsuarioHandler = async (payload, setType) => {
  const result = await getMonitoreoUsuario(payload);
  if (result) {
    setEstadisticasPersona(result);
    setType("personal");
  }
};

export const getInteraccionesUnDiaHandler = async (payload) => {
  const result = await getInteraccionesUnDia(payload);
  if (result) {
    setInteraccionesUnDia(result.interacciones, result.interacciones_backoffice);
    // setType("personal");
  }
};
